import { menuFirsts } from "../../constants/menu"
import StallReclaim from "../../pages/stallReclaim/stallReclaim"

/**
 * เมนูเรียกคืนแผงค้า — ฝั่งเจ้าหน้าที่เท่านั้น ไม่มีหน้าฝั่งผู้เช่า
 * (ผู้เช่าไม่ได้เป็นคนเริ่มเรื่อง องค์การเป็นฝ่ายออกคำสั่ง)
 */
const routeStallReclaim = [
  {
    ...menuFirsts.STALL_RECLAIM,
    /** key ต้องตรงกับ menuFirstKey ที่ backend ส่งมา ไม่งั้น PrivateRoute หา activeMenu ไม่เจอ ปุ่มจะ disable หมด */
    key: menuFirsts.STALL_RECLAIM.key,
    name: menuFirsts.STALL_RECLAIM.name,
    textName: menuFirsts.STALL_RECLAIM.textName,
    active: false,
    appBar: true,
    component: StallReclaim
  }
]

export default routeStallReclaim
